import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistoryMdfeResponse = (value) => {
  if (typeof value !== 'string') return value;
  let v = value.trim();
  if (v.startsWith('"') && v.endsWith('"')) v = JSON.parse(v);
  return v;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistoryMdfeResponse(value));

const isHistoryMdfeAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];
  return candidates.some((value) => {
    if (value === 'erro_auth') return true;
    if (typeof value !== 'string') return false;
    let v = value.trim();
    if (v.startsWith('"') && v.endsWith('"')) v = JSON.parse(v);
    try { v = base64_decode(v); } catch (_) { return v === 'erro_auth'; }
    return v === 'erro_auth';
  });
};

const handleHistoryMdfeError = (xhr, reject, rejectMessage) => {
  if (isHistoryMdfeAuthError(xhr)) showDuplicateLoginAlert();
  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const raw = sessionStorage.getItem('ddesp');
  return raw !== null ? JSON.parse(base64_decode(raw)) : null;
};

const ajaxHistoryMdfeEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  encodeDd = true,
}) =>
  new Promise(function (resolve, reject) {
    try {
      $.ajax({
        url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
        type,
        dataType: 'text',
        headers: { Authorization: 'Bearer ' + tk },
        data: {
          pp: base64_encode('mdfe'),
          [routeField]: encodeRoute ? base64_encode(ll) : ll,
          ...(encodeDd ? { dd: base64_encode(JSON.stringify(dd)) } : {}),
          tk,
          ...extraData,
        },
        success: function (data) {
          if (parseType === 'jsonBase64') {
            resolve([200, JSON.parse(base64_decode(data))]);
            return;
          }
          if (parseType === 'base64') {
            resolve([200, base64_decode(data)]);
            return;
          }
          resolve([200, data]);
        },
        error: function (xhr) {
          handleHistoryMdfeError(xhr, reject, rejectMessage);
        },
      });
    } catch (err) {
      reject([500, { message: err + ' Server Error' }]);
    }
  });

const RestHistoryMdfePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'pesqMdfe':
      return ajaxHistoryMdfeEvent({
        type: 'Post',
        ll: 'pesqMdfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });

    case 'situacao':
      return ajaxHistoryMdfeEvent({
        type: 'Post',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });

    case 'downXML':
      return ajaxHistoryMdfeEvent({
        type: 'Get',
        ll: 'dwnXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });

    case 'salvaConfigTabela':
      return ajaxHistoryMdfeEvent({
        type: 'Post',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });

    default:
      return new Promise((_, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistoryMdfeGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableMdfe':
      return ajaxHistoryMdfeEvent({
        type: 'Get',
        ll: 'getConfigTableMdfe',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });

    default:
      return new Promise((_, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistoryMdfePost, RestHistoryMdfeGet };
